<header>
  <nav class="navbar navbar-dark navbar-expand-lg mdlb-header">
    <div class="d-flex flex-grow-1">
      <a class="navbar-brand d-none d-lg-inline-block" href="/">
        <img class="mdlb-ui-padding" src="assets/images/logo/makery-logo.svg" alt="Makery Global Webshop"
             title="Makery Global Webshop">
      </a>
      <a class="navbar-brand d-lg-none d-inline-block" href="/">
        <img src="assets/images/logo/makery-logo.svg" alt="Makery Global Webshop"
             title="Makery Global Webshop">
      </a>
      <div class="w-100 text-right">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#myNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </div>
    <div class="collapse navbar-collapse flex-grow-1 text-right mdlb-ui-padding" id="myNavbar">
      <ul class="navbar-nav ml-auto flex-nowrap">
        <li class="nav-item dropdown" >
          <a class="nav-link badge badge-pill badge-light menu-item m-2 p-2" href="#"
             id="navbarDropdownMenuLink33" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img width="22px" src="assets/images/icon/clock.svg" alt="Makery Global Webshop"
                 title="Makery Global Webshop"/>
            <span class="mdlb-header-dropdown mr-2 ml-2 mdlb-color-white">
                           {{availableDate.dateString}}
                        </span>
          </a>

          <div class="dropdown-menu bg-primary mdlb-header-dropdown-menu-left"
               aria-labelledby="navbarDropdownMenuLink33">
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               *ngFor="let availableDate of availableDateList"
               (click)="changeDate(availableDate)">{{availableDate.dateString}}
            </a>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link badge badge-pill badge-light menu-item m-2 p-2" href="#"
             id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img width="22px" src="assets/images/icon/world.svg" alt="Makery Global Webshop"
                 title="Makery Global Webshop"/>
            <span class="mdlb-header-dropdown mr-2 ml-2 mdlb-color-white">{{translate.currentLang | uppercase}}</span>
          </a>
          <div class="dropdown-menu bg-primary" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               (click)="switchLang('en')">
              {{'headerBar.english' | translate}}
            </a>
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               (click)="switchLang('hu')">
              {{'headerBar.hungarian' | translate}}
            </a>
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               (click)="switchLang('sk')">
              {{'headerBar.slovakian' | translate}}
            </a>
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               (click)="switchLang('de')">
              {{'headerBar.german' | translate}}
            </a>
          </div>
        </li>

        <li class="nav-item dropdown" *ngIf="currentRestaurant">
          <a class="nav-link badge badge-pill badge-light menu-item m-2 p-2" href="#"
             id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img width="22px" src="assets/images/icon/cook.svg" alt="Makery Global Webshop"
                 title="Makery Global Webshop"/>
            <span class="mdlb-header-dropdown mr-2 ml-2 mdlb-color-white">
                           {{currentRestaurant.name | uppercase}}
                        </span>
          </a>

          <div class="dropdown-menu bg-primary mdlb-header-dropdown-menu-left"
               aria-labelledby="navbarDropdownMenuLink2">
            <a class="dropdown-item mdlb-color-white"
               href="javascript:void(0)"
               *ngFor="let restaurant of restaurants"
               (click)="changeRestaurant(restaurant)">{{restaurant.name | uppercase}}
            </a>
          </div>
        </li>

        <li class="nav-item" *ngIf="currentRestaurant">

          <a class="nav-link badge badge-pill badge-light menu-item m-2 p-2" href="#" (click)="showDailySum()"
             id="navbarMenuDailySum" aria-haspopup="true" aria-expanded="false">
            <img width="13px" src="assets/images/icon/sum.png" alt="Makery Global Webshop"
                 title="Makery Global Webshop"/>
            <span class="mdlb-header-dropdown mr-2 ml-2 mdlb-color-white">
                           {{"DailySum" | translate}}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
  <!-- Fordítások be/ki kapcsolása -->
  <div class="mdlb-translate-switcher
{{(turnOffTranslations)?'mdlb-translate-switcher-red':''}}">

    <div class="custom-control custom-switch " [hidden]="isProduction">
      <input type="checkbox" class="custom-control-input" id="translateSwitch"
             [(ngModel)]="turnOffTranslations" (change)="translateOnOff()">
      <label class="custom-control-label"
             for="translateSwitch">{{'general.translateOnOff' | translate }}</label>
    </div>
  </div>
</header>
